import { UserAnswersService } from "@/common/api.service"
import { SurveyUserAnswersService } from "@/common/api.service"
import { TestExamUserAnswersService } from "@/common/api.service"
import { ExerciseUserAnswersService } from "@/common/api.service"

import { ADD_USER_ANSWERS,ADD_DAILY_USER_ANSWERS,FETCH_DAILY_USER_ANSWERS, ADD_SURVEY_USER_ANSWERS, ADD_TEST_EXAM_USER_ANSWERS,ADD_EXERCISE_USER_ANSWERS, UPDATE_EXERCISE_USER_ANSWERS_GRADE, RESET_STATE} from "./actions.type"
import { SET_USER_ANSWERS,SET_ERROR_USER_ANSWERS, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        useranswers: [],
        useranswererrors: null,
    }
}

let state = initialState()

const getters = {
    useranswers(state) {
        return state.useranswers
    }
}

const actions = {

    //QUIZ
    async [ADD_USER_ANSWERS](context, payload) {
        return await UserAnswersService.create(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
        });
    },  
    async [FETCH_DAILY_USER_ANSWERS](context, slug) {
        const { data } = await UserAnswersService.get(slug)
        context.commit(SET_USER_ANSWERS, data.data)
        return data;
    },
    async [ADD_DAILY_USER_ANSWERS](context, payload) {
        return await UserAnswersService.createdailyquiz(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
        });
    },  

    //SURVEY
    async [ADD_SURVEY_USER_ANSWERS](context, payload) {
        return await SurveyUserAnswersService.create(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
        });
    },  

    //TESTS
    async [ADD_TEST_EXAM_USER_ANSWERS](context, payload) {
        if(payload.hasOwnProperty('module_id')){
            return await TestExamUserAnswersService.createTests(payload)
            .then(({ data }) => {
              return data
            })
        }
        else{
            return await TestExamUserAnswersService.createExams(payload)
            .then(({ data }) => {
              return data
            })
        }
    },  
    
    //EXERCISE
    async [ADD_EXERCISE_USER_ANSWERS](context, payload) {
        return await ExerciseUserAnswersService.create(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
        });
    },  
    async [UPDATE_EXERCISE_USER_ANSWERS_GRADE](context, payload) {
      return await ExerciseUserAnswersService.update(payload, payload.exercise_id)
      .then(({ data }) => {
        return data
      })
      .catch(error => {
        context.commit(SET_ERROR_USER_ANSWERS, error.response.data.errors)
      });
  },  

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_USER_ANSWERS](state, error) {
        state.questionerrors = error
    },      
    [SET_USER_ANSWERS](state, useranswersdata) {
        state.useranswers = useranswersdata
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};